import PropTypes from 'prop-types';
import React, { isValidElement, PureComponent } from 'react';

import Content, { subComponentsShape, subComponents } from './Content';

const pick = (object, keys) =>
  keys.reduce((acc, key) => {
    if (object && object.hasOwnProperty(key)) {
      acc[key] = object[key];
    }

    return acc;
  }, {});

class ContentContainer extends PureComponent {
  static propTypes = {
    children: PropTypes.shape(subComponentsShape),
    forcedContentStyles: PropTypes.object,
  };

  static defaultProps = {};

  render() {
    const { children, ...otherProps } = this.props;

    let contentProps = null;

    if (typeof children === 'function') {
      contentProps = { children };
    }

    if (typeof children === 'object') {
      if (Array.isArray(children) || isValidElement(children)) {
        contentProps = { body: children };
      } else {
        contentProps = pick(children, subComponents);
      }
    }

    return <Content {...contentProps} {...otherProps} />;
  }
}

export default ContentContainer;
